import { Component, HostBinding, Input } from '@angular/core';
import { UilabBaseComponentsModule } from '@uilab/base-components-angular';

@Component({
    selector: 'ds-uilab-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [UilabBaseComponentsModule],
})
export class DsBannerComponent {
    @Input() status!: 'success' | 'warning' | 'error' | 'information';

    @HostBinding('class.banner--success') get success() {
        return this.status === 'success';
    }
    @HostBinding('class.banner--warning') get warning() {
        return this.status === 'warning';
    }
    @HostBinding('class.banner--error') get error() {
        return this.status === 'error';
    }
    @HostBinding('class.banner--information') get information() {
        return this.status === 'information';
    }
}
